const tabs = document.querySelectorAll(".page-tab");
const tabButtons = document.querySelectorAll('.tab-btn');
const sections = document.querySelectorAll(".tab-content");

// Set initial state for tabs and tab contents
let initialActiveTab = false;
tabs.forEach((tab, index) => {
    if (tab.classList.contains('active')) {
        initialActiveTab = true;
    }
    if (!initialActiveTab && index === 0) {
        tab.classList.add('active');
        sections[index].classList.add('active');
    }
});

// Function to update page for the selected tab
const updatePageForTab = (tab) => {
    // Update the URL with the selected tab's data-tab attribute
    const newUrl = `${window.location.pathname}?tab=${tab.dataset.tab}`;
    history.pushState({ tab: tab.dataset.tab }, tab.textContent, newUrl);

    // Highlight the selected tab
    tabs.forEach((t) => t.classList.remove("active"));
    tab.classList.add("active");

    // Toggle active class for corresponding section
    sections.forEach((section) => {
        const sectionTab = section.getAttribute('data-tab');
        if (sectionTab === tab.dataset.tab) {
            section.classList.add("active");
        } else {
            section.classList.remove("active");
        }
    });
};

// Event listener for tab clicks
tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
        updatePageForTab(tab);
    });
});

// Check for tab parameter in URL and activate the corresponding tab
const urlParams = new URLSearchParams(window.location.search);
const tabParam = urlParams.get("tab");
if (tabParam) {
    const activeTab = document.querySelector(`[data-tab="${tabParam}"]`);
    if (activeTab) {
        updatePageForTab(activeTab);
    }
}

// Event listener for tab button clicks
tabButtons.forEach(button => {
    button.addEventListener('click', (event) => {
        const tabId = button.getAttribute('data-tab');
        // Hide all tab contents
        sections.forEach(tabContent => {
            tabContent.classList.remove('active');
        });
        // Hide all tab buttons
        tabButtons.forEach(btn => {
            btn.classList.remove('active');
        });
        // Show the clicked tab content
        const tabContentToShow = document.querySelector(`.tab-content[data-tab="${tabId}"]`);
        if (tabContentToShow) {
            tabContentToShow.classList.add('active');
            event.currentTarget.classList.add('active');
        }
    });
});